import React from 'react';

import { DateValue } from '@internationalized/date';

import {
  currencyString,
  formatDate,
  isDefined,
  isLineOfCredit,
  ProductTypeT,
} from '@consumer-frontend/nc-utils';

import { NcAlert } from '../NcAlert';
import { NcStaticBadge, staticBadgeConfigs } from '../NcStaticBadge';

import '@consumer-bootstrap/netcredit.scss';

export type NcNextMinimumAmountPropsT = {
  amountDue: number;
  originalAmountDue: number;
  dueDate?: DateValue;
  isAutopay?: boolean;
  isPaymentPending?: boolean;
  isReplacement?: boolean;
  loanType?: ProductTypeT;
  showAutoPayBadges?: boolean;
};
export type NcNextMinimumAmountT = React.FC<NcNextMinimumAmountPropsT>;

export const NcNextMinimumAmount: NcNextMinimumAmountT = ({
  amountDue,
  dueDate,
  isAutopay,
  isPaymentPending,
  isReplacement,
  loanType,
  originalAmountDue,
  showAutoPayBadges,
}) => {
  const displayDueDate = dueDate && formatDate(dueDate);

  return (
    <div className="payment-amount-option-label">
      <span>{(isDefined(loanType) && isLineOfCredit(loanType)) ? 'Minimum payment' : 'Next installment amount'}</span>

      <span data-chromatic="ignore">
        <span className="currency-amount">{currencyString(amountDue || originalAmountDue)}</span>
        {amountDue !== 0 && amountDue < originalAmountDue && <span> remaining</span>}
        <span> due {displayDueDate}</span>
      </span>

      {/* BADGES */}
      {amountDue === 0 && (
        <NcStaticBadge config={staticBadgeConfigs.PAID} />
      )}

      {amountDue !== 0 && showAutoPayBadges && (
        <>
          {isPaymentPending && (
            <NcStaticBadge config={staticBadgeConfigs.AUTOPAY_PENDING} />
          )}
          {isAutopay && !isPaymentPending && (
            <NcStaticBadge config={staticBadgeConfigs.AUTOPAY_SCHEDULED} />
          )}
        </>
      )}

      {/* REPLACEMENT ALERT */}
      {/* TODO: Removed for MVP but will be added back in NCFE-10010 */}
      {false && isReplacement && (
        <NcAlert
          className="mt-2"
          dismissible={false}
          variant="info"
        >
          This payment will{' '}
          <span className="fw-bold">replace your AutoPay payment</span>{' '}
          of {currencyString(amountDue)} scheduled for{' '}
          <span data-chromatic="ignore">{displayDueDate}</span>.
        </NcAlert>
      )}
    </div>
  );
};
